"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MaterialVariantsData_variants, _MaterialVariantsData_geometryData, _MaterialVariantsData_variantIndex;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialVariantsData = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class MaterialVariantsData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(id, version) {
        super(id, version);
        // #region Properties (1)
        _MaterialVariantsData_variants.set(this, []);
        _MaterialVariantsData_geometryData.set(this, []);
        _MaterialVariantsData_variantIndex.set(this, void 0);
    }
    // #endregion Constructors (1)
    // #region Public Accessors (2)
    get geometryData() {
        return __classPrivateFieldGet(this, _MaterialVariantsData_geometryData, "f");
    }
    get variants() {
        return __classPrivateFieldGet(this, _MaterialVariantsData_variants, "f");
    }
    get variantIndex() {
        return __classPrivateFieldGet(this, _MaterialVariantsData_variantIndex, "f");
    }
    set variantIndex(value) {
        __classPrivateFieldSet(this, _MaterialVariantsData_variantIndex, value, "f");
        for (let i = 0; i < this.geometryData.length; i++) {
            const variant = this.geometryData[i].materialVariants.find(v => v.variant === __classPrivateFieldGet(this, _MaterialVariantsData_variantIndex, "f"));
            if (variant) {
                this.geometryData[i].material = variant.material;
            }
            else {
                this.geometryData[i].material = this.geometryData[i].standardMaterial;
            }
        }
    }
    // #endregion Public Accessors (2)
    // #region Public Methods (1)
    /**
     * Clones the scene graph data.
     */
    clone() {
        return new MaterialVariantsData(this.id, this.version);
    }
}
exports.MaterialVariantsData = MaterialVariantsData;
_MaterialVariantsData_variants = new WeakMap(), _MaterialVariantsData_geometryData = new WeakMap(), _MaterialVariantsData_variantIndex = new WeakMap();
//# sourceMappingURL=MaterialVariantsData.js.map